import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import React, { useContext } from "react";
import {
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
} from "../constructTextFromValues";
import { psychologistDiagnosisOptions } from "../../Options/psychologistOptions";
import psychologyDiagnosisIcon from "../../../../assets/doctorIcons/psychologyDiagnosis.svg";
import { checkEmpty } from "../../../../helpers/utility";

const PsychologyDiagnosisSummary = ({ context }) => {
  const { formData } = useContext(context);
  const constructDiagnosisSummaryItems = () => {
    const diagnosisSummaryItems = [];
    if (checkEmpty(formData?.psychology_diagnosis)) {
      diagnosisSummaryItems.push({
        key: "1",
        label: "Psychology Diagnosis",
        children: (
          <>
            {getLabelTagsWithDescription(
              psychologistDiagnosisOptions,
              formData?.psychology_diagnosis
            )}
            {getLabelTagsWithDynamicInputs(
              formData?.psychology_diagnosis?.others
            )}
          </>
        ),
      });
    }
    return diagnosisSummaryItems;
  };
  const diagnosisSummaryItems = constructDiagnosisSummaryItems();
  return (
    <SummaryWrapper
      items={diagnosisSummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={psychologyDiagnosisIcon} width={18} preview={false} />
            <span style={{ fontSize: "16px", fontWeight: "normal" }}>
              Psychology Diagnosis
            </span>
          </Space>
        </span>
      }
    />
  );
};

export default PsychologyDiagnosisSummary;
